export default "__VITE_ASSET__CC4KSG3W__"